import { AxiosInstance } from 'axios';
import { BaseHTTP } from './base.http';

interface MercadoPagoOAuthUrlRequest {
  redirect_uri: string;
  organization_id: number;
}

interface MercadoPagoOAuthUrlResponse {
  url: string;
  businessId?: number;
  organizationId?: number;
}

export interface IntegrationStatusResponse {
  buk: {
    integrated: boolean;
    lastSyncAt?: string;
  };
  mercadopago: {
    integrated: boolean;
    lastSyncAt?: string | null;
  };
  global66: {
    integrated: boolean;
    initialBalance: number | null;
  };
  hasCompanyToken: boolean;
}

export interface Global66StatusResponse {
  integrated: boolean;
  initialBalance: number | null;
}

export type BukRemunerationUpdateResponse = unknown[];

export class IntegrationsAPI {
  private http!: AxiosInstance;

  constructor() {
    this.http = BaseHTTP.getInstance().http;
  }

  getMercadoPagoOAuthUrl(businessId: number, payload: MercadoPagoOAuthUrlRequest) {
    const path = `v1/business/${businessId}/integrations/mercadopago/oauth/url`;
    return this.http.post<MercadoPagoOAuthUrlResponse>(path, payload);
  }

  getIntegrationsStatus(businessId: number) {
    const path = `v1/business/${businessId}/integrations/status`;
    return this.http.get<IntegrationStatusResponse>(path);
  }

  syncBukIntegration(businessId: number) {
    const path = `v1/business/${businessId}/remuneration/update-buk`;
    console.log('[Buk sync] request', { method: 'GET', path, businessId });
    return this.http.get<BukRemunerationUpdateResponse>(path);
  }

  getCompanyToken(businessId: number) {
    const path = `v1/business/${businessId}/integrations/company-token`;
    return this.http.get<{ companyToken: string }>(path);
  }

  getGlobal66WebhookUrl(businessId: number) {
    const path = `v1/business/${businessId}/integrations/global66/webhook-url`;
    return this.http.get<{ url: string }>(path);
  }

  getGlobal66Status(businessId: number) {
    const path = `v1/business/${businessId}/integrations/global66/status`;
    return this.http.get<Global66StatusResponse>(path);
  }

  saveGlobal66Credentials(businessId: number, payload: { apiKey: string; initialBalance: number }) {
    const path = `v1/business/${businessId}/integrations/global66/credentials`;
    return this.http.post<{ message: string }>(path, payload);
  }

  deleteGlobal66Integration(businessId: number) {
    const path = `v1/business/${businessId}/integrations/global66`;
    return this.http.delete<{ message: string }>(path);
  }
}

export default new IntegrationsAPI();
